<template>
  <div id="app">
    <!-- 路由出口 -->
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import "./styles/index.scss";

.el-carousel__indicators {
  left: unset !important;
  right: 0 !important;
}

.el-carousel__button {
  width: 8px !important;
  height: 8px !important;
  border-radius: 50%;
}

html {
  scroll-behavior: smooth;
}

/*滚动条美化*/
*::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

*::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

*::-webkit-scrollbar-thumb {
  background-color: #d8d9da;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*@media screen and (max-width:860px) {*/
/*//手机*/
/*// 不显示滚动条*/
/*    *::-webkit-scrollbar {*/
/*        display: none !important;*/
/*        width: 0px;*/
/*        height: 0px;*/
/*    }*/
/*}*/

/* 解决ios,iphone的safari浏览器h5自动放大，input获得焦点页面被放大 */
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  input,
  input:focus,
  textarea,
  textarea:focus,
  select,
  select:focus {
    font-size: 16px !important;
  }
}

.flex-center-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
